import { render, staticRenderFns } from "./addPatientService.vue?vue&type=template&id=e6242dce&"
import script from "./addPatientService.vue?vue&type=script&lang=js&"
export * from "./addPatientService.vue?vue&type=script&lang=js&"
import style0 from "./addPatientService.vue?vue&type=style&index=0&id=e6242dce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports